module.exports = __webpack_public_path__ + "img/Refute_rumor.c3db46ab.png";